export default __webpack_public_path__ + "18e4e3b305b1cdaaed119ba1dec89d26.png";